import React from 'react';
import { useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import Lottie from 'lottie-react';
import { useNavigate } from 'react-router-dom';
import {
  useTranslator,
  useAppContext,
  callNativeMobileApp,
} from '@front-activerse/common-components';

const DietSettingsLoaderPage: React.FC = () => {
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();

  const { t } = useTranslator();

  const {
    lotties: { preloader },
    consts: { APP_BRAND },
  } = useAppContext();

  useEffect(() => {
    let i = 0;

    const updateProgress = () => {
      let diff = 0;
      if (i < 30) {
        diff = 25 / 30;
      } else if (i >= 30 && i < 45) {
        diff = 0;
      } else if (i >= 45 && i < 55) {
        diff = 25 / 10;
      } else if (i >= 55 && i < 70) {
        diff = 0;
      } else if (i >= 70 && i < 80) {
        diff = 25 / 10;
      } else if (i >= 80 && i < 95) {
        diff = 0;
      } else if (i >= 95 && i < 100) {
        diff = 25 / 5;
      } else {
        setProgress(100);
      }
      setProgress((prevProgress) => prevProgress + diff);
      i++;
    };

    const timer = setInterval(
      () => {
        updateProgress();
      },
      APP_BRAND === 'raize' ||
        APP_BRAND === 'radiance' ||
        APP_BRAND === 'resilient' ||
        APP_BRAND === 'dtba' ||
        APP_BRAND === 'shestrong' ||
        APP_BRAND === 'oxy' ||
        APP_BRAND === 'hashimoto' ||
        APP_BRAND === 'maxx'
        ? 40
        : 100
    );

    return () => {
      clearInterval(timer);
    };
  }, [APP_BRAND]);

  useEffect(() => {
    if (progress >= 100) {
      console.log('close modal');
      callNativeMobileApp({
        action: 'close_modal',
      });
      navigate('/meals/day-plan');
    }
  }, [progress, navigate]);

  return (
    <div className="diet-generate-loader full-height2 text-center d-flex align-items-center">
      <Container>
        <Row>
          <Col xs="12" md={{ size: 4, offset: 4 }}>
            <h2 className="title-large semi-bold mb-s px-4">{t('goalSettings.loader.header')}</h2>
            <div className="animation-loader-wrapper">
              <Lottie
                animationData={preloader}
                loop={
                  APP_BRAND !== 'raize' &&
                  APP_BRAND !== 'resilient' &&
                  APP_BRAND !== 'dtba' &&
                  APP_BRAND !== 'shestrong' &&
                  APP_BRAND !== 'oxy' &&
                  APP_BRAND !== 'hashimoto' &&
                  APP_BRAND !== 'maxx'
                    ? true
                    : false
                }
              />
              {!(
                APP_BRAND === 'raize' ||
                APP_BRAND === 'radiance' ||
                APP_BRAND === 'resilient' ||
                APP_BRAND === 'dtba' ||
                APP_BRAND === 'shestrong' ||
                APP_BRAND === 'oxy' ||
                APP_BRAND === 'hashimoto' ||
                APP_BRAND === 'maxx'
              ) && (
                <h2 className="loader-progress-value semi-bold">{Math.round(progress) + '%'}</h2>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DietSettingsLoaderPage;
